export default {
  // Custom themes
  // NOTE: All keys must be in lowercase
  qmkey: {
    name: "QmKey",
    logo: "/logos/qmkey.png",
    loginBackground: "/logos/bg_qmkey_iso_1920x1080.jpg",
    light: {
      primary: "#85a43c",
      secondary: "#29A1C5",
      ctas:"#000fff",
      primaryl1: "#f3f7ea"
    },
  },
  qmfood: {
    name: "QmFood",
    logo: "/logos/qmfood.svg",
    loginBackground: "/logos/bg_food_iso_1920x1080.jpg",
    light: {
      primary: "#f7a501",
      secondary: "#29A1C5",
      ctas:"#000fff",
      primaryl1: "#fff6e5"
    },
  },
  qmhealth: {
    name: "QmHealth",
    logo: "/logos/qmsalud.svg",
    loginBackground: "/logos/bgsalud1920x1080.jpg",
    light: {
      primary: "#29A1C5",
      secondary: "#85a43c",
      ctas: "#ffa500",
      primaryl1: "#e8f6fa"
    },
  },
  pmcons: {
    name: "PmCons",
    logo: "/logos/qmsalud.svg",
    loginBackground: "/logos/bg_construction.jpg",
    light: {
      primary: "#29A1C5",
      secondary: "#85a43c",
      ctas: "#ffa500",
      primaryl1: "#e8f6fa"
    },
  },
  // qmdefault: {
  //   name: "QmDefault",
  //   logo: "/logos/qmkey.png",
  //   loginBackground: "/logos/qmkey_bg_default.jpg",
  //   light: {
  //     primary: "#85a43c",
  //   },
  // },
  

  // Default theme
  name: "QmDefault",
  logo: "/logos/qmkey.png",
  loginBackground: "/logos/qmkey_bg_default.png",
  light: {
    primary: "#85a43c",
    secondary: "#29A1C5",
    ctas:"#000fff",
    primaryl1: "#f3f7ea"
  },
  dark: {
    primary: "#85a43c",
    secondary: "#29A1C5",
    ctas:"#000fff",
    primaryl1: "#f3f7ea"
  },

}
